var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _path5, _path6, _path7, _path8, _rect6, _rect7, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreCardTemplateEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 137,
    viewBox: "0 0 170 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 98,
    height: 42,
    rx: 8,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 98,
    height: 42,
    rx: 8,
    fill: "url(#paint0_linear_1919_41746)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 98,
    height: 42,
    rx: 8,
    fill: "#6C738A",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2192 67.9704C45.5996 67.9704 49.1507 64.4303 49.1507 60.0633C49.1507 55.6964 45.5996 52.1562 41.2192 52.1562C36.8387 52.1562 33.2877 55.6964 33.2877 60.0633C33.2877 64.4303 36.8387 67.9704 41.2192 67.9704Z",
    fill: "#F8FAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.671 60.0624H57.0817C55.6218 60.0624 54.4379 58.8821 54.4379 57.4267C54.4379 55.9713 55.6218 54.791 57.0817 54.791H104.671C106.131 54.791 107.315 55.9713 107.315 57.4267C107.315 58.8821 106.131 60.0624 104.671 60.0624Z",
    fill: "#F8FAFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.246 70.6054H57.0817C55.6218 70.6054 54.4379 69.4251 54.4379 67.9697C54.4379 66.5143 55.6218 65.334 57.0817 65.334H115.246C116.706 65.334 117.89 66.5143 117.89 67.9697C117.89 69.4251 116.706 70.6054 115.246 70.6054Z",
    fill: "#F8FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4515 81.1478H57.0817C55.6218 81.1478 54.4379 79.9676 54.4379 78.5122C54.4379 77.0567 55.6218 75.8765 57.0817 75.8765H91.4515C92.9115 75.8765 94.0954 77.0567 94.0954 78.5122C94.0954 79.9676 92.9115 81.1478 91.4515 81.1478Z",
    fill: "#F8FAFE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 42,
    rx: 8,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 42,
    rx: 8,
    fill: "url(#paint1_linear_1919_41746)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2192 20.9704C18.5996 20.9704 22.1507 17.4303 22.1507 13.0633C22.1507 8.69637 18.5996 5.15625 14.2192 5.15625C9.83873 5.15625 6.28767 8.69637 6.28767 13.0633C6.28767 17.4303 9.83873 20.9704 14.2192 20.9704Z",
    fill: "#F8FAFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6707 13.0624H30.0817C28.6218 13.0624 27.4379 11.8821 27.4379 10.4267C27.4379 8.97127 28.6218 7.79102 30.0817 7.79102H77.6707C79.1306 7.79102 80.3146 8.97127 80.3146 10.4267C80.3146 11.8821 79.1306 13.0624 77.6707 13.0624Z",
    fill: "#F8FAFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2461 23.6054H30.0817C28.6218 23.6054 27.4379 22.4251 27.4379 20.9697C27.4379 19.5143 28.6218 18.334 30.0817 18.334H88.2461C89.706 18.334 90.8899 19.5143 90.8899 20.9697C90.8899 22.4251 89.706 23.6054 88.2461 23.6054Z",
    fill: "#F8FAFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4515 34.1478H30.0817C28.6218 34.1478 27.4379 32.9676 27.4379 31.5122C27.4379 30.0567 28.6218 28.8765 30.0817 28.8765H64.4515C65.9115 28.8765 67.0954 30.0567 67.0954 31.5122C67.0954 32.9676 65.9115 34.1478 64.4515 34.1478Z",
    fill: "#F8FAFE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 95,
    width: 98,
    height: 42,
    rx: 8,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 95,
    width: 98,
    height: 42,
    rx: 8,
    fill: "url(#paint2_linear_1919_41746)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2192 115.97C18.5996 115.97 22.1507 112.43 22.1507 108.063C22.1507 103.696 18.5996 100.156 14.2192 100.156C9.83873 100.156 6.28767 103.696 6.28767 108.063C6.28767 112.43 9.83873 115.97 14.2192 115.97Z",
    fill: "#F8FAFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6707 108.062H30.0817C28.6218 108.062 27.4379 106.882 27.4379 105.427C27.4379 103.971 28.6218 102.791 30.0817 102.791H77.6707C79.1306 102.791 80.3146 103.971 80.3146 105.427C80.3146 106.882 79.1306 108.062 77.6707 108.062Z",
    fill: "#F8FAFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2461 118.605H30.0817C28.6218 118.605 27.4379 117.425 27.4379 115.97C27.4379 114.514 28.6218 113.334 30.0817 113.334H88.2461C89.706 113.334 90.8899 114.514 90.8899 115.97C90.8899 117.425 89.706 118.605 88.2461 118.605Z",
    fill: "#F8FAFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4515 129.148H30.0817C28.6218 129.148 27.4379 127.968 27.4379 126.512C27.4379 125.057 28.6218 123.876 30.0817 123.876H64.4515C65.9115 123.876 67.0954 125.057 67.0954 126.512C67.0954 127.968 65.9115 129.148 64.4515 129.148Z",
    fill: "#F8FAFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.228 134.229C163.533 137.924 157.541 137.924 153.845 134.229L133.771 114.154C130.076 110.459 130.076 104.467 133.771 100.771C137.467 97.0762 143.459 97.0762 147.154 100.771L167.229 120.845C170.924 124.541 170.924 130.533 167.228 134.229Z",
    fill: "#B5BAC4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.657 106.657C137.866 108.448 134.962 108.448 133.172 106.657L125.343 98.8287C123.552 97.0375 123.552 94.1342 125.343 92.343C127.134 90.5523 130.037 90.5523 131.829 92.343L139.657 100.171C141.448 101.963 141.448 104.866 139.657 106.657Z",
    fill: "#E5E7EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.017 41.9834C114.372 27.3389 90.6283 27.3389 75.9836 41.9834C61.3388 56.628 61.3388 80.372 75.9836 95.0165C90.6283 109.661 114.372 109.661 129.017 95.0165C143.661 80.372 143.661 56.628 129.017 41.9834ZM124.045 90.0441C112.146 101.943 92.854 101.943 80.9552 90.0441C69.0564 78.1454 69.0564 58.8537 80.9552 46.9554C92.854 35.0563 112.146 35.0563 124.045 46.9554C135.944 58.8541 135.944 78.1459 124.045 90.0441Z",
    fill: "#B3B8C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1919_41746",
    x1: 27,
    y1: 70.5194,
    x2: 126.876,
    y2: 70.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1919_41746",
    x1: 0,
    y1: 23.5194,
    x2: 99.8759,
    y2: 23.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1919_41746",
    x1: 0,
    y1: 118.519,
    x2: 99.8759,
    y2: 118.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardTemplateEmptyState);
export default __webpack_public_path__ + "8dac97077fa1a4835b6288a673ab83a1.svg";
export { ForwardRef as ReactComponent };